import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {fetchOnInit} from "./features/fetchOnInit.feature.store";
import {LamellaListingItem} from "../types/lamella-listing-item.type";
import {computed, inject, Signal} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";



type AvailableProductStoreState = {
    availableLamellas: Array<LamellaListingItem>,
    recentProducts: Array<LamellaListingItem>
}

export const availableProductsStore = signalStore(

    { providedIn: "root" },

    withState<AvailableProductStoreState>({
        availableLamellas: [],
        recentProducts: []
    }),

    //sessionSave('availableLamellas',['availableLamellas', 'recentProducts']),

    fetchOnInit<AvailableProductStoreState, ['availableLamellas'], LamellaListingItem>('/api/lamella?listing=true', ['availableLamellas']),

    withMethods((
        store,
        http = inject(HttpClient)
    ) => ({

        addRecentProduct: (product: LamellaListingItem) => {
            const recentProducts = [...store.recentProducts()];

            if ( recentProducts.includes(product) ) {
                //reorder the array to put the product as first
                recentProducts.unshift( recentProducts.splice( recentProducts.indexOf(product) , 1 )[0] );
                patchState(store, { recentProducts: recentProducts } );

            } else {
                patchState(store, {recentProducts: [product, ...recentProducts]});

            }
        },

        findFromAvailableProducts: (productCode: string) => {
            const allProducts = store.availableLamellas();
            return store.availableLamellas().find( product => product.productCode === productCode );
        },

        getById: (id: unknown): Signal<LamellaListingItem> => computed(() => store.availableLamellas().find( (item: LamellaListingItem) => item.id === id)),

        provideProduct: async (productCode: string): Promise<LamellaListingItem|undefined> => {
            const product = store.availableLamellas().find( (item: LamellaListingItem) => item.productCode === productCode);
            return product ? product : await new Promise((resolve)=> http.get<LamellaListingItem[]>(`/api/lamella?listing=true&productCode=${productCode}`).pipe(map((items) => items.length>0 ? items[0] : undefined )).subscribe(resolve))
        },



    })),

)